module.exports = __webpack_public_path__ + "img/brand-pic2-06.2b16490f.png";